import amex from "assets/images/brand-cards/amex.png";
import diners from "assets/images/brand-cards/diners.png";
import discover from "assets/images/brand-cards/discover.png";
import jcb from "assets/images/brand-cards/jcb.png";
import mastercard from "assets/images/brand-cards/mastercard.png";
import visa from "assets/images/brand-cards/visa.png";

const brandCardImages: Record<string, string> = {
  amex,
  diners,
  discover,
  jcb,
  mastercard,
  visa,
};
export const hasBrandCardImage = (name: string): boolean => {
  return Object.keys(brandCardImages).includes(name?.toLowerCase());
};

export const getBrandCardImage = (name: string): string | undefined => {
  return brandCardImages[name.toLowerCase()];
};
